import { AsideMenuTopBar } from '@single-platform/components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { LinkPopupContentContainer, LinkPopupHeaderStyles } from '../../linkPopup.style';
import { ParagraphStyles } from '../linkPopupDescription/linkPopupDescription.style';

export const LinkPopupFatca = ({ onClose, header }) => {
  const { t } = useTranslation();
  return (
    <>
      <LinkPopupHeaderStyles>
        <AsideMenuTopBar handleClose={onClose} />
        <div>{t(header)}</div>
      </LinkPopupHeaderStyles>
      <LinkPopupContentContainer>
        <ParagraphStyles>{t('link_popup_fatca_header')}</ParagraphStyles>
        <ParagraphStyles>{t('link_popup_fatca_subheader')}</ParagraphStyles>
        <ParagraphStyles>{t('link_popup_fatca_aditional_information')}</ParagraphStyles>
      </LinkPopupContentContainer>
    </>
  );
};
